<form [formGroup]="form">
  <app-input-group>
    <label appLabel>{{ 'chargeInformation.chargeTemplate' | translate }}</label>
    <select appSelect [collection]="templatePricesList" formControlName="chargeLoadTemplateCarrier">
    </select>
  </app-input-group>
  <app-input-group>
    <label appLabel>{{ 'chargeInformation.validFrom' | translate }}</label>
    <input type="date" appInput formControlName="validFrom">
  </app-input-group>
  <app-input-group>
    <label appLabel>{{ 'chargeInformation.validTo' | translate }}</label>
    <input type="date" appInput formControlName="validTo">
  </app-input-group>
</form>
